import { Button, Input, Select, Space } from "antd";
import { ColumnsType } from "antd/es/table";
import { Link } from "react-router-dom";
import AddIcon from "../../../assets/icons/AddIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import SelectDownIcon from "../../../assets/icons/SelectDownIcon";
import ViewIcon from "../../../assets/icons/ViewIcon";
import CustomTable from "../../../components/ui/CustomTable";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { countParPageSerialNumber } from "../../../utils/number";
import { addKeyInArray } from "../../../utils/utils";

export default function RequestsList() {
  const { page, limit, handlePagination, handleLimit } = useTable();
  const { open, handleOpen, handleClose } = useModal();

  const columns: ColumnsType<LeaveDataType> = [
    {
      title: "#SL",
      dataIndex: "index",
      align: "center",
      width: 50,
      render: (_: any, __: any, index: number) =>
        countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Client Id",
      dataIndex: "clientId",
    },
    {
      title: "Company Name",
      dataIndex: "title",
    },
    {
      title: "Email Address",
      dataIndex: "email",
    },
    {
      title: "Location",
      dataIndex: "location",
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (value: string) => {
        const isTrial = value.includes("Trial");
        const isTrialExpired = value === "Trial Expired";
        const displayValue = isTrialExpired ? "Inactive" : value;

        return (
          <span
            className={`px-2 py-1 rounded text-xs font-medium ${
              displayValue === "Active"
                ? "bg-green-100 text-green-600"
                : displayValue === "Inactive"
                ? "bg-red-100 text-red-600"
                : isTrial
                ? "bg-[#F0F3F9] text-[#5E718D]"
                : "bg-yellow-100 text-yellow-600"
            }`}
          >
            {displayValue}
          </span>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "key",
      align: "center",
      render: (val) => (
        <Space size={8}>
          <Link to={`/admin/businesses/requests-list/${val}`}>
            <Button
              icon={<ViewIcon />}
              size="small"
              className="action-button"
              danger
            />
          </Link>
        </Space>
      ),
    },
  ];

  return (
    <>
      <SidebarLayout title="Requests">
        <CustomTable
          loading={false}
          limit={limit}
          page={page}
          columns={columns}
          total={100}
          dataSource={addKeyInArray(data)}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={
            <>
              <Input suffix={<SearchIcon />} placeholder="Search by Name, Id" />

              <Select
                // defaultValue="lucy"
                style={{ width: 120 }}
                allowClear
                suffixIcon={<SelectDownIcon />}
                options={[
                  { value: "Active", label: "Active" },
                  { value: "Inactive", label: "Inactive" },
                  { value: "Review", label: "Review" },
                  { value: "Trial", label: "Trial" },
                ]}
                placeholder="Status"
              />

              <Select
                // defaultValue="lucy"
                className="w-[120px]"
                allowClear
                suffixIcon={<SelectDownIcon />}
                options={[
                  { value: "Active", label: "Active" },
                  { value: "Inactive", label: "Inactive" },
                  { value: "Review", label: "Review" },
                  { value: "Trial", label: "Trial" },
                ]}
                placeholder="digiGo"
              />

              <Link to="/admin/businesses/requests-list/add-new">
                <Button
                  className="middle-button"
                  type="primary"
                  icon={<AddIcon />}
                >
                  Add new Business
                </Button>
              </Link>
            </>
          }
        />
      </SidebarLayout>
    </>
  );
}

interface LeaveDataType {
  key: string;
  title: string;
  clientId: string;
  email: string;
  location: string;
  status: string;
}

const data: LeaveDataType[] = [
  {
    key: "1",
    title: "upka",
    clientId: "XYZ2541",
    email: "name@gmail.com",
    location: "Dhaka",
    status: "Active",
  },
  {
    key: "2",
    title: "upka",
    clientId: "XYZ2541",
    email: "name@gmail.com",
    location: "Dhaka",
    status: "Review",
  },
  {
    key: "3",
    title: "upka",
    clientId: "XYZ2541",
    email: "name@gmail.com",
    location: "Dhaka",
    status: "Trial Expired",
  },

  {
    key: "4",
    title: "upka",
    clientId: "XYZ2541",
    email: "name@gmail.com",
    location: "Dhaka",
    status: "14 Days Trial",
  },
];
